// extracted by css-extract-rspack-plugin
var _1 = "wh8dDUGGqIU7HXCa";
var _2 = "dyfttAGppoXVFM38";
var _3 = "l_2fGBwleHQizHF8";
var _4 = "l_2fGBwleHQizHF8";
var _5 = "JXgXK1_sKwQNQ131";
export { _1 as "button", _2 as "column", _3 as "latest-info", _4 as "latestInfo", _5 as "pic" }
